import React from 'react';
import {AttendanceStatus, Event, GenerateCertificateState, ScheduleStatus} from '../../schema';
import Tooltip from '../../ui/Tooltip';
import IconInfo from '../icon/IconInfo';
import CertificateAvailability from '../../models/event/CertificateAvailability';

type Props = {
  event: Event
  status: AttendanceStatus
  state: GenerateCertificateState
}

/**
 * Displays a notice to the user that some actions in the menu on the attendee's profile may not be available
 */
export function AttendeeMenuNotice({event, status, state}: Props) {
  if (!event.confirmed) {
    return <div className="bg-yellow-light px-5 py-3">
      Confirm the event to activate more actions
      <Tooltip
        content={<div className='w-52'>When an event is not confirmed, you cannot change the status of attendee to Participated and
          generate a certificate</div>} label='confirmed_tooltip'>
        <IconInfo className="text-gray-dark ml-1"/>
      </Tooltip>
    </div>;
  }
  if (status === AttendanceStatus.CANCELLED) {
    return <div className="bg-yellow-light px-5 py-3">
      Actions with the attendee are limited because of <strong>Cancelled</strong> status
      <Tooltip
        content={<div className='w-52'>When an attendee is cancelled, you cannot
          generate a certificate</div>} label='cancelled_tooltip'>
        <IconInfo className="text-gray-dark ml-1"/>
      </Tooltip>
    </div>;
  }
  if (event.schedule.status === ScheduleStatus.InFuture) {
    return <div className="bg-yellow-light px-5 py-3">
      Some actions are not available because the event has not started yet
      <Tooltip
        content={<div className='w-52'>When an event is in the future, you cannot change the status of attendee to Participated and
          generate a certificate</div>} label='in_future_tooltip'>
        <IconInfo className="text-gray-dark ml-1"/>
      </Tooltip>
    </div>;
  }
  if (status === AttendanceStatus.REGISTERED && CertificateAvailability.isPotentiallyAvailable(state)) {
    return <div className="bg-yellow-light px-5 py-3">
      Set status to <strong>Participated</strong> to activate more actions
      <Tooltip
        content={<div className='w-52'>When an attendee is registered, you cannot
          generate a certificate</div>} label='registered_tooltip'>
        <IconInfo className="text-gray-dark ml-1"/>
      </Tooltip>
    </div>;
  }
  return (<></>);
}
